import { merge } from 'lodash-es'
import { Options as SearchOptions } from 'minisearch'
import { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { UseMiniSearch, useMiniSearch } from 'react-minisearch'

const defaultOptions: SearchOptions = {
  fields: [],
  searchOptions: {
    fuzzy: true,
    prefix: true,
  },
}

export type UseQuerySearch<T = unknown> = UseMiniSearch<T> & {
  query: string
  setQuery: Dispatch<SetStateAction<string>>
}

export function useQuerySearch<T = unknown>(
  documents: T[],
  options: SearchOptions<T>
): UseQuerySearch<T> {
  const {
    add,
    addAll,
    addAllAsync,
    autoSuggest,
    clearSearch,
    clearSuggestions,
    discard,
    discardAll,
    getById,
    isIndexing,
    miniSearch,
    rawResults,
    remove,
    removeAll,
    removeById,
    replace,
    search,
    searchResults,
    suggestions,
  } = useMiniSearch(documents, merge({}, defaultOptions, options))

  useEffect(() => {
    removeAll()

    addAll(documents ?? [])

    if (query) {
      search(query)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [documents])

  const [query, setQuery] = useState('')

  useEffect(() => {
    if (query) {
      search(query)
    } else {
      clearSearch()
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query])

  return {
    add,
    addAll,
    addAllAsync,
    autoSuggest,
    clearSearch,
    clearSuggestions,
    discard,
    discardAll,
    getById,
    isIndexing,
    miniSearch,
    rawResults,
    remove,
    removeAll,
    removeById,
    replace,
    search,
    searchResults,
    suggestions,
    query,
    setQuery,
  }
}
